var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAimarketplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3656.43,
    height: 2851.9,
    viewBox: "0 0 3656.43 2851.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LAMP"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2879.6 2847 334.6 2847 1374.6 377.6 1839.6 377.6 2879.6 2847",
    fill: "#d0f0e4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1563 191.8 1607.1 147.7 1651.2 191.8",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1607.1,
    y1: 147.7,
    x2: 1607.1,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1607.1,
    cy: 383.6,
    r: 71,
    fill: "#ffcf2d",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.6,377.6H1374.7l6.2-28.3c20.4-93.2,115.5-160.8,226.3-160.8,55.4,0,106.9,16.9,147,45.4s69,68.7,79.2,115.3Z",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "BOOKSHELF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2276.4,
    y: 1970.2,
    width: 47.2,
    height: 298,
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3180.7,2268.2H2912a16,16,0,0,1-16-18l37.4-315.7a16.18,16.18,0,0,1,16-14.2h268.7a16,16,0,0,1,16,18L3196.7,2254A16.18,16.18,0,0,1,3180.7,2268.2Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3034.3,2268.2H2822.1a21.79,21.79,0,0,1-21.6-24.3l27.2-229.9a21.82,21.82,0,0,1,21.6-19.2h217.3Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3058.1,2268.2H2855.6a21.79,21.79,0,0,1-21.6-24.3l27.2-229.9a21.82,21.82,0,0,1,21.6-19.2h205.1a10.89,10.89,0,0,1,10.8,12.2l-29.8,251.5A10.84,10.84,0,0,1,3058.1,2268.2Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2326.6,
    y: 2015,
    width: 81.9,
    height: 253.2,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2380,
    y: 2015,
    width: 115.3,
    height: 253.2,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2635 2268.2 2603.1 2268.2 2484.4 1987.2 2516.3 1987.2 2635 2268.2",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2695.8 2268.2 2636.4 2268.2 2534.2 2029.9 2593.6 2029.9 2695.8 2268.2",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2190.8,
    y: 2015,
    width: 82.6,
    height: 253.2,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2190.8,
    y: 1820.9,
    width: 384.2,
    height: 49.4,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2190.8,
    y: 1783.1,
    width: 486.7,
    height: 39.8,
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2190.8,
    y: 1725.7,
    width: 328.5,
    height: 56.4,
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2190.8,
    y: 1682.6,
    width: 384.2,
    height: 42.1,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3237.9,1571.6l-.3,1.7-45.4,297H2771l45.4-297,.6-4.2c7.2-14.6,51.2-25.9,104.5-25.9,58.3,0,105.5,13.5,105.5,30.1,0-16.6,47.2-30.1,105.5-30.1C3188.8,1543.3,3234.7,1555.8,3237.9,1571.6Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2982.1,
    y1: 1870.4,
    x2: 3027.1,
    y2: 1573.4,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2982.1,1870.4c0-16.6-47.2-30.1-105.5-30.1s-105.5,13.5-105.5,30.1Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3193.1,1870.4c0-16.6-47.2-30.1-105.5-30.1s-105.5,13.5-105.5,30.1Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2983.7,1864.1c-.6-16.6,46.1-31.7,104.4-33.8,36.4-1.3,72.3,3.8,91.2,11.1l45-282.9",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3204.3,1472.5H2826.1v-84.2a15,15,0,0,1,15-15h348.3a15,15,0,0,1,15,15v84.2Z",
    fill: "#fff",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3234.5,1369.3H2908.6a9.07,9.07,0,0,1-9.1-9.1v-33.5a9.07,9.07,0,0,1,9.1-9.1h325.9a9.07,9.07,0,0,1,9.1,9.1v33.5A9.13,9.13,0,0,1,3234.5,1369.3Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2860.6,
    y: 1286.2,
    width: 386.6,
    height: 31.4,
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3240.2,1286.2H2945.1a7,7,0,0,1-7-7v-25.3a7,7,0,0,1,7-7h295.1a7,7,0,0,1,7,7v25.3A7,7,0,0,1,3240.2,1286.2Z",
    fill: "#fff",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2314.9,
    y: 1163.6,
    width: 113.5,
    height: 308.9,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2269.1,
    y: 1163.6,
    width: 45.8,
    height: 308.9,
    fill: "#fff",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2192.1,
    y: 1163.6,
    width: 77,
    height: 308.9,
    fill: "#fff",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.4,
    y: 1219.4,
    width: 99.5,
    height: 253.2,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450.6,1472.5h-39.2a7,7,0,0,1-7-7V1226.2a7,7,0,0,1,7-7h39.2a7,7,0,0,1,7,7v239.3A7.09,7.09,0,0,1,2450.6,1472.5Z",
    fill: "#fff",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2542.9 1219.4 2542.9 1358.2 2489 1219.4 2542.9 1219.4",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2773.3,1472.5H2614.1a8.49,8.49,0,0,1-7.9-5.4l-103.4-266.2a8.47,8.47,0,0,1,7.9-11.6h159.2a8.49,8.49,0,0,1,7.9,5.4l103.4,266.2A8.47,8.47,0,0,1,2773.3,1472.5Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2799.3,1472.5H2640.1a8.49,8.49,0,0,1-7.9-5.4l-103.4-266.2a8.47,8.47,0,0,1,7.9-11.6h159.2a8.49,8.49,0,0,1,7.9,5.4l103.4,266.2A8.47,8.47,0,0,1,2799.3,1472.5Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3078.9,1007.1a171.44,171.44,0,0,1-94.5-329.6Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3032,
    y1: 1013.6,
    x2: 3032,
    y2: 1074.7,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3032,
    cy: 842.2,
    r: 145.2,
    fill: "#fff",
    stroke: "#3fb1b5",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3092.7 1074.3 2971.8 1074.3 3031.8 1044.2 3092.7 1074.3",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3247.2,1074.7V2847h-54.7V2718a52,52,0,0,0-52-52H2296.9a52,52,0,0,0-52,52v129h-54.1V1074.7Z",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3171.3,2616.9H2264.7a20.89,20.89,0,0,1-20.9-20.9V2335.1a20.89,20.89,0,0,1,20.9-20.9h906.6a20.89,20.89,0,0,1,20.9,20.9V2596A20.89,20.89,0,0,1,3171.3,2616.9Z",
    fill: "none",
    stroke: "#3fb1b5",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2765.8 831.3 2765.8 1074.7 2680.6 1074.7 2765.8 831.3",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2765.8,831.3l-.6,1.8-84.1,241.6h-391l84.1-241.6,2.7-7.7h0c12.6-18.1,47.5-31.3,89.1-32h4c48.6,0,91.9,16.9,99.8,39.1,7.8-22.2,49.2-39.1,97.8-39.1C2715.2,793.4,2756.9,809.7,2765.8,831.3Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2569.7,
    y1: 832.5,
    x2: 2484.8,
    y2: 1069.7,
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2484.6,1071.7H2290.1c7.2-22.5,47.6-39.8,96.2-39.8C2435.1,1031.9,2477.4,1049.2,2484.6,1071.7Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2680.6,1071.7H2486.1c7.2-22.5,47.6-39.8,96.2-39.8C2631.1,1031.9,2673.4,1049.2,2680.6,1071.7Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2652.9,2391.5a14.19,14.19,0,0,1,14.2-14.2h106.1a14.19,14.19,0,0,1,14.2,14.2",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2190.8,
    y1: 1870.4,
    x2: 3247.2,
    y2: 1870.4,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2190.8,
    y1: 1472.5,
    x2: 3247.2,
    y2: 1472.5,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2190.8,
    y1: 2268.2,
    x2: 3247.2,
    y2: 2268.2,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2320.8 703.1 2190.8 1074.7 3247.2 1074.7 3377.2 703.1",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "PLANT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3495.8,2751.6a161,161,0,0,1-10.5,57.3,67.12,67.12,0,0,1-62.9,43H3210.7c-27.8,0-53-17-62.8-43a161,161,0,0,1-10.5-57.3c0-58,30.7-109.2,77.6-139.8V2578c0,14.8,45.5,26.8,101.5,26.8s101.5-12,101.5-26.8v33.9C3465.1,2642.4,3495.8,2693.6,3495.8,2751.6Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3418.2,2602.6v9c-16.1,12.8-59.9,19.6-101.5,19.6s-85.4-6.8-101.5-19.6v-9c1.9,4.3,10,9.9,28,14.6,19.6,5.2,45.7,8,73.5,8s53.9-2.8,73.5-8C3408.2,2612.4,3416.2,2606.8,3418.2,2602.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3418.2,2578c0,14.8-45.5,26.8-101.5,26.8s-101.5-12-101.5-26.8a8.83,8.83,0,0,1,2.1-5.5c9.6-12.1,50.4-21.3,99.4-21.3s89.8,9.1,99.4,21.3A9.46,9.46,0,0,1,3418.2,2578Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3180.8,
    cy: 2696.3,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3224.2,
    cy: 2727.8,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3278.2,
    cy: 2690.4,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3270.6,
    cy: 2775.4,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3222.6,
    cy: 2812.7,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3174.2,
    cy: 2775.4,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3231.2,
    cy: 2648.8,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3333.1,2645.7a12.8,12.8,0,1,1-12.8,12.8A12.8,12.8,0,0,1,3333.1,2645.7Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3322.4,
    cy: 2736.1,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3359.4,
    cy: 2787.1,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3311.4,
    cy: 2825.5,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3373.1,
    cy: 2705.5,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3410.2,
    cy: 2653,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3452.4,
    cy: 2695.5,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3404.1,
    cy: 2737.4,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3461.9,
    cy: 2764.2,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3423,
    cy: 2813.4,
    r: 12.8,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3540.9,2422.2s95-51.3,110.7,38.3c18.2,103.5-105.4,194.6-105.4,194.6s-26.6-65.9-97.9-122.7C3386.6,2483.3,3437.8,2353.1,3540.9,2422.2Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3354.4,2308.1c45.1.4,109.9-91.2,48.7-191.7-73.9-121.4-86.6-191.7-86.6-191.7s-108.7,143.8-90.2,254.1C3246.6,2299.6,3354.4,2308.1,3354.4,2308.1Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3362.2,2247.1c65.9,17.4,128.5-22.7,129.8-114.1,2.3-161.6,32.9-214.2,32.9-214.2s-205.3,73.9-236.4,188.7C3258.9,2216.9,3362.2,2247.1,3362.2,2247.1Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3086.8,2353.5c-2.4.2-4.9.4-7.6.6-141.8,10.6-182.6,140.4-182.6,140.4s-8.7-9.4-6.9-41.9c3.4-83.8,80.5-170.4,168.5-115.4C3068,2343.4,3077.6,2348.7,3086.8,2353.5Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3247.6,2385.4c-25,1.6-82.1,8.5-160.8-31.9-9.2-4.7-18.8-10.1-28.6-16.3-88-55-163.1,31.6-166.5,115.4-.2,4.1.8,8.2,1,12.2-8.3-72.8-8.1-254,212.2-247.9C3256.3,2221.3,3247.6,2385.4,3247.6,2385.4Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3283.6,2572.7s26.1-363.7-326.6-316.2",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3524.9,1918.8c-222.2,227-180.8,653.9-180.8,653.9-23.4-163.3,120.2-325.6,196.7-154.8,22.8,50.8,5.3,237.1,5.3,237.1",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "CHAIR_TABLE",
    "data-name": "CHAIR & TABLE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CHAIR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.5,2286.8l-29.8,26.1a110,110,0,0,1-12.8-18.9L4.1,1947.8a21.7,21.7,0,0,1,19.1-32h26a56.18,56.18,0,0,1,49.6,29.7l146.1,272.2A56,56,0,0,1,232.5,2286.8Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.3,2294.4h0L306,2383.2v-9a90.78,90.78,0,0,1,72.5-88.9L657,2228.1A67.71,67.71,0,0,1,738.3,2294.4Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.3,2847V2413.9a56.66,56.66,0,0,0-68.1-55.5l-271.5,55.7a96.32,96.32,0,0,0-70.7,60L135.7,2847",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,1945.9l211.1,393.3a86.43,86.43,0,0,0,93.6,43.8l431.6-88.6",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "BOOKS"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 526.3,
    y: 1973.2,
    width: 365.3,
    height: 48.8,
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825,1920.2c4.4,4.1,7.1,11.5,7.1,17.7,0,12.4-10.8,25.1-24.2,25.1H474.7a10.5,10.5,0,0,0,10.5,10.5H887.3a40.29,40.29,0,0,0,27.6-10.6,34.58,34.58,0,0,0,11.4-25.6c0-20-17.5-36.1-39-36.1H485.2a10.5,10.5,0,0,0-10.5,10.5v1.9H807.9A25.89,25.89,0,0,1,825,1920.2Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.8,1913.7v48.4h-24v4H809.1a28,28,0,0,0,10.5-2h0a27.52,27.52,0,0,0,9.4-6.2,28.21,28.21,0,0,0-19.9-48.2H474.8v4Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.5,1913.7v48.4H807.9a24.2,24.2,0,0,0,0-48.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.5,
    y1: 1913.7,
    x2: 489.5,
    y2: 1962.1,
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.4,1948v40.4h27.9v-35.2a15.19,15.19,0,0,1,15.2-15.2h12.4v-5.2H778.5A15.24,15.24,0,0,0,763.4,1948Z",
    fill: "#ffcf2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TABLE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.2,2063.8a38.62,38.62,0,0,1,38.6-38.6h759a38.62,38.62,0,0,1,38.6,38.6",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158,2847,943.7,2100.6c-9.5-33-42.2-56-79.6-56H614.4c-37.4,0-70.1,23-79.6,56L320.6,2847",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CHARACTER"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHOES"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1337.9,2717.8v108.8a20.36,20.36,0,0,0,20.4,20.4h272s1.6-50.5-39.8-64.6c-70.3-23.9-103.1-64.6-103.1-64.6Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1489.2,2773.5c11.1-3.1,51.1-25.2,37.4-38.9-6.5-6.5-22.1,0-22.1,0",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.2,2788.5c11.1-3.1,49.5-27.8,34.4-39.9-11.4-9.2-28.5,8.6-28.5,8.6",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.8,2726.6l-157.9,49.1v-57.9h149.6A101.7,101.7,0,0,0,1495.8,2726.6Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678.9,2717.8v108.8a20.36,20.36,0,0,0,20.4,20.4h272s1.6-50.5-39.8-64.6c-70.3-23.9-103.1-64.6-103.1-64.6Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.2,2773.5c11.1-3.1,51.1-25.2,37.4-38.9-6.5-6.5-22.1,0-22.1,0",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1871.2,2788.5c11.1-3.1,49.5-27.8,34.4-39.9-11.4-9.2-28.5,8.6-28.5,8.6",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.8,2726.6l-157.9,49.1v-57.9h149.6A101.7,101.7,0,0,0,1836.8,2726.6Z",
    fill: "#fe5244"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEGS"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1411.4 1634.8 1312.9 2666 1518.9 2666 1622.4 2166.3 1664.7 2272.8 1664.7 2666 1879.2 2666 1879.2 2225.1 1764.8 1634.8 1411.4 1634.8",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1518.7,
    y1: 1882.5,
    x2: 1422.9,
    y2: 2666,
    fill: "none",
    stroke: "#9a3b82",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1768.2 2666 1768.2 2225.1 1633.8 1684.8",
    fill: "none",
    stroke: "#9a3b82",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1661.7,2272.8l-128.4-372.9a31.8,31.8,0,0,0-30.1-21.4",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1395.1 1805.3 1411.4 1634.8 1764.8 1634.8 1774.9 1687.2 1395.1 1805.3",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1879.6,2717.8H1663.9a14.72,14.72,0,0,1-14.7-14.7v-22.4a14.72,14.72,0,0,1,14.7-14.7h215.7a14.72,14.72,0,0,1,14.7,14.7v22.4A14.79,14.79,0,0,1,1879.6,2717.8Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1522.6,2717.8H1306.9a14.72,14.72,0,0,1-14.7-14.7v-22.4a14.72,14.72,0,0,1,14.7-14.7h215.7a14.72,14.72,0,0,1,14.7,14.7v22.4A14.79,14.79,0,0,1,1522.6,2717.8Z",
    fill: "#9a3b82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BOOK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2098.3,1665l67.6,252.9-337,90.1-67.7-253.1a29.5,29.5,0,1,0-57,15.2l67.7,253.1-7.4,2-67.6-252.9a38.39,38.39,0,0,1,26-46.7l1.2-.3,327.2-87.5A38.53,38.53,0,0,1,2098.3,1665Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.7,1753.2l67.6,252.9-7.4,2L1761.2,1755a29.5,29.5,0,1,0-57,15.2l67.7,253.1-7.4,2-67.6-252.9a37.18,37.18,0,1,1,71.8-19.2Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.2,1754.9l63.5,237.6-57,15.2-63.5-237.6a29.5,29.5,0,0,1,57-15.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SHIRT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2099.3,1799,1946,1851.8l-121-217H1356c-79.7,0-139.3-73.3-123-151.3l48.8-234.4a158.29,158.29,0,0,1,154.9-126h320.7a158.17,158.17,0,0,1,156.2,133.1l48.3,228.2Z",
    fill: "#ffcf2d",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331,1632.3a126,126,0,0,1-100.4-113.5,61,61,0,0,1,13.9-7.2c36.3-13.4,77.8,8.6,92.9,49.1C1346.7,1586.1,1343.5,1612.7,1331,1632.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEAD"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "NECK",
    points: "1680.2 982.5 1680.2 1123.2 1524.9 1123.2 1560.7 1029.6 1680.2 982.5",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "HAIR",
    d: "M1715.9,923.3c-.1,0-.3.1-.4.1h0l-46.1,12.2a50.35,50.35,0,0,0-34.6,32h-17.7a20.31,20.31,0,0,0-20.3,20.3v.3a20.25,20.25,0,0,0,18.5,20.2l-.1.1s-8.2,39-56.1,25.9c0,0,1.9-102.6,3.9-134.5,1.7-26.3,141.2-76.1,154.1-54.9,11.4,18.8-1.8,27.6-13,31.5,19.8-4.2,57.2-9.8,61,6.9C1769.5,902.8,1730,919.6,1715.9,923.3Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("g", {
    id: "HEAD-2",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1724.9,995.2H1720l1.4,24a30.14,30.14,0,0,1-30,31.8h-21.6a37.73,37.73,0,0,1-37.7-37.7v-4.7h-14.9a20.31,20.31,0,0,1-20.3-20.3V988a20.31,20.31,0,0,1,20.3-20.3h17.7a50.14,50.14,0,0,1,34.6-32l46.1-12.2h0l15.8,63.3C1733,990.8,1729.2,995.2,1724.9,995.2Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1636.8,1015.2c-2.1,22,19.9,37.7,40.7,37.7",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1628.7,991.7a14.08,14.08,0,0,0-14.1-14.1",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1707.9,
    cy: 969.7,
    rx: 3.7,
    ry: 7.7,
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1691.9,953.5a53.39,53.39,0,0,1,29.9-9.4",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "BACKPACK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1644.3,1698.9s122.5,5.3,165.6-93l-22.8-41.7-68.1,26.2Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.4,1097.4a24.56,24.56,0,0,0-22.5,24.4v492.7a85.1,85.1,0,0,1-85.1,85.1H1445.9a85.09,85.09,0,0,1-84.6-94.2v-.1l68-467.7a47,47,0,0,1,46.5-40.2Z",
    fill: "#fe5244",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.4,1097.4a24.6,24.6,0,0,0-15.3,7.1,24,24,0,0,0-6.9,13.9c-.1,1.1-.2,2.2-.2,3.3l-4,37.7-48,455a85.1,85.1,0,0,1-85.1,85.1H1446a85.09,85.09,0,0,1-84.6-94.2v-.1l30.7-211.4,37.3-256.3a51.76,51.76,0,0,1,1.4-6.6,46.92,46.92,0,0,1,45-33.6h247.6Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.3,1195.5l-17.9,134.3c-5.9,27.5-27.3,42.2-58.3,47.2l-212,30.8,30.9-212.4h257.3Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.8,1097.4h-5.3a20.14,20.14,0,0,0-19.9,16.2l-31.2,201.3a59.7,59.7,0,0,1-58.3,47.2H1406a36.94,36.94,0,0,1-36.1-44.9l37.6-170.8a62.48,62.48,0,0,1,61-49Z",
    fill: "#fe5244",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1555,1418.1l49.7-303.9a12.76,12.76,0,0,1,12.5-10.7h0a12.68,12.68,0,0,1,12.5,14.8L1580,1422.2a12.76,12.76,0,0,1-12.5,10.7h0A12.68,12.68,0,0,1,1555,1418.1Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.9,1418.1l49.7-303.9a12.76,12.76,0,0,1,12.5-10.7h0a12.68,12.68,0,0,1,12.5,14.8l-49.7,303.9a12.76,12.76,0,0,1-12.5,10.7h0A12.68,12.68,0,0,1,1443.9,1418.1Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.9,1123.3l-48.9.2v-1.7a24,24,0,0,1,7.2-17.3,24.36,24.36,0,0,1,15.3-7.1h4C1758.8,1098.4,1768.5,1108.8,1768.9,1123.3Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAND"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2081,1805.3l41.2,106.3a31,31,0,0,1-20.6,41l-90.5,24.8a17,17,0,0,1-15.6-3.5l-9.2-8,18.8-5a18.21,18.21,0,0,0,13.5-18.5l-2.1-21.2a18.2,18.2,0,0,0-17.6-17.4h1c-11.5-.4-22.7-7.5-27.2-18.1l-14.4-38.3Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1988.2,1968l14.8-4c8.3-2.2,13.9-8.9,13.5-17.5l-1.1-23.2a18.2,18.2,0,0,0-17.6-17.4h0a29.64,29.64,0,0,1-26.2-18.1l-15.4-36.3",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2036.6,1967.8a23.27,23.27,0,0,0,17.3-23.6l-1.4-29.6",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2074.9,1957.9a23.27,23.27,0,0,0,17.3-23.6l-1.4-29.6",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732.3,1362.1l24.2,126.6a205.82,205.82,0,0,0,22.4,61.7l167,301.4,153.3-52.8",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1833.6,1649.2l-54.7-98.8a211,211,0,0,1-20.5-53,72.61,72.61,0,0,1,16.3-3.4c43.2-3.8,81.5,32.5,85.6,81C1862.7,1604.4,1852,1631.5,1833.6,1649.2Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAimarketplace);
export default __webpack_public_path__ + "static/media/aimarketplace.c82be0362fcc3b00da98e7953a03cca6.svg";
export { ForwardRef as ReactComponent };